import React from 'react'
import Parser from 'html-react-parser';

export default function Kvkk() {

    const wordContent = `
    
<p class=MsoNormal align=center style='text-align:center;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span class=GramE><b><span
style='font-size:18.0pt;font-family:"Arial",sans-serif;color:black;mso-font-kerning:
0pt'>att</span></b></span><b><span style='font-size:18.0pt;font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'> <span class=SpellE>app</span> Kişisel
Verilerin Korunması Politikası Hakkında Bilgilendirme ve İletişim İzni Onay
Metni<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>Yürürlük Tarihi: Nisan
2025<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>24.03.2016 tarihinde kabul edilen 6698 Sayılı
“Kişisel Verilerin Korunması Kanunu” yürürlüğe girmiştir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Uygulamalarımızı kullanırken veya başka
yollarla tarafımıza iletmiş olduğunuz kişisel bilgilerinizin güvenliğinin
sağlanması bizim için oldukça önemlidir. 6698 Sayılı “Kişisel Verilerin
Korunması Kanunu” ve bu mevzuatta belirtilen bazı tanımlar hakkında sizi
bilgilendirmek isteriz:<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Öncelikle bilmenizi isteriz ki, yasa gereği mezkûr
yasa hükümleri, kişisel verileri işlenen gerçek kişiler ile bu verileri tamamen
veya kısmen otomatik olan ya da herhangi bir veri kayıt sisteminin parçası
olmak kaydıyla otomatik olmayan yollarla işleyen gerçek ve tüzel kişiler
hakkında uygulanır.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Bu kanun kapsamında,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>a) Açık rıza: Belirli bir konuya ilişkin,
bilgilendirilmeye dayanan ve özgür iradeyle açıklanan rızayı,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>b) İlgili kişi: Kişisel verisi işlenen gerçek
kişiyi,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>c) Kişisel veri: Kimliği belirli veya
belirlenebilir gerçek kişiye ilişkin her türlü bilgiyi,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span class=GramE><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>ç</span></span><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>)
Kişisel verilerin işlenmesi: Kişisel verilerin tamamen veya kısmen otomatik
olan ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik
olmayan yollarla elde edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi,
değiştirilmesi, yeniden düzenlenmesi, açıklanması, aktarılması, devralınması,
elde edilebilir hâle getirilmesi, sınıflandırılması ya da kullanılmasının
engellenmesi gibi veriler üzerinde gerçekleştirilen her türlü işlemi,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>d) Veri işleyen: Veri sorumlusunun verdiği
yetkiye dayanarak onun adına kişisel verileri işleyen gerçek veya tüzel kişiyi,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>e) Veri kayıt sistemi: Kişisel verilerin
belirli kriterlere göre yapılandırılarak işlendiği kayıt sistemini,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>f) Veri sorumlusu: Kişisel verilerin işleme
amaçlarını ve vasıtalarını belirleyen, veri kayıt sisteminin kurulmasından ve
yönetilmesinden sorumlu olan gerçek veya tüzel kişiyi ifade eder.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>1. Kişisel Verilerin
Korunması ve Rıza Metninin Amacı ve att <span class=SpellE>app</span> Veri
Sorumlusu Konumu<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span class=GramE><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>att</span></span><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'> <span
class=SpellE>app</span>, kullanıcılarına ilişkin kişisel veriler bakımından
Kişisel Verilerin Korunması Kanunu kapsamında “veri sorumlusu” sıfatına sahip
olup işbu Kişisel Verilerin Korunması ve Rıza Metni ile söz konusu Kanun
uyarınca kullanıcıların att <span class=SpellE>app</span> tarafından
gerçekleştirilen kişisel veri işleme faaliyetleri hakkında aydınlatılması ve
aşağıda 2 maddede belirtilen durumlar için açık rızalarının temini hedeflenmektedir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><i><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>i. Kullanıcıların Açık
Rızası Doğrultusunda İşlenecek Kişisel Veriler ve İşleme Amaçları:<o:p></o:p></span></i></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Kanun’un 5/2 ile 6/3 maddesinde yer alan
kişisel veri işleme şartlarının karşılanamadığı durumlar için att <span
class=SpellE>app</span> tarafından kişisel verilerin işlenebilmesi için
kullanıcıların açık rızasının alınması gerekmektedir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><i><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>ii. Kullanıcılara Ait
Kişisel Verilerin İşlenme Amacı:<o:p></o:p></span></i></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Kullanıcılara ait kişisel veriler aşağıda ve
Kanun’un 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve
amaçları çerçevesinde işlenmektedir. Kullanıcılara ait kişisel veriler;<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>a) att <span class=SpellE>app</span>
tarafından sunulan ürün/hizmetlerden ilgili kişileri faydalandırmak için
gerekli çalışmaların iş birimleri tarafından yapılması ve ilgili iş
süreçlerinin yürütülmesi,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>b) att <span class=SpellE>app</span>
tarafından ticari ve/veya iş stratejilerinin planlanması ve icrası,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>c) att <span class=SpellE>app</span> ile iş
ilişkisi içerisinde olan ilgili kişilerin hukuki, teknik ve ticari-iş
güvenliğinin temini ile tarafımızın sunduğu ürün ve hizmetlerin ilgili
kişilerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre
özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması için gerekli olan
aktivitelerin planlanması ve icrası,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span class=GramE><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>ç</span></span><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>)
İlgililerin olası hak ve alacak taleplerinin tesisi<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>d) Yetkili kuruluşlara mevzuattan kaynaklı
bilgi verilmesi<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>e) Ziyaretçi kayıtlarının oluşturulması ve
takibi<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>f) att <span class=SpellE>app</span> ve att <span
class=SpellE>app</span> adına şubeler, bağlı şirketler, iş ortaklıkları
tarafından ya da internet sitelerimiz ile sosyal medya sayfalarımız veya ve
bunlarla sınırlı olmamak üzere her türlü kanallar aracılığı ile tüm yasal
mevzuat kapsamında, yükümlülüklerin yerine getirilmesinin sağlanması,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>g) Kullanıcılara daha iyi hizmet verebilme,
çeşitli avantajlar sağlayıp sunma, satış, pazarlama, bilgilendirme,
promosyonlar hakkında bilgi verebilme, kampanya ve koşulları hakkında bilgi
sağlama, anket, kullanıcı memnuniyet araştırmalarını yapabilme, satın alma
işlemlerinizi sağlama hızlandırma,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span class=GramE><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>ğ</span></span><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>)
Kullanıcılara yönelik kampanyaların oluşturulması, çapraz satış yapılması,
hedef kitle belirlenmesi,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>h- Kullanıcı hareketlerinin takip edilerek
kullanıcı deneyimini arttırıcı faaliyetlerin yürütülmesi ve att <span
class=SpellE>app</span> internet sitesi ile mobil uygulamanın işleyişinin
geliştirilmesi ve kullanıcı ihtiyaçlarına göre kişiselleştirilmesi, doğrudan ve
doğrudan olmayan pazarlama, kişiye özel pazarlama ve yeniden pazarlama
faaliyetlerinin yürütülmesi, kişiye özel segmentasyon, hedefleme, analiz ve iç
raporlama faaliyetlerinin yürütülmesi, pazar araştırmaları, kullanıcı
memnuniyeti aktivitelerinin planlanması ve icrası ile kullanıcı ilişkileri
yönetimi süreçlerinin planlanması ve icrası amaçları dahil olmak üzere att <span
class=SpellE>app</span> ürün ve/veya hizmetlerinin satış ve pazarlama
süreçlerinin planlanması ve icrası, att <span class=SpellE>app</span>
tarafından sunulan ürün ve/veya hizmetlere bağlılık oluşturulması ve/veya
arttırılması süreçlerinin planlanması ve icrası kapsamında kullanıcının
vereceği onayı doğrultusunda işlenebilecek ve işbu Kişisel Verilerin Korunması
Metninde belirtilen taraflarla paylaşılabilecektir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>2. Kullanıcılara Ait
Kişisel Verilerin Aktarımı<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Kullanıcılara ait kişisel veriler, att <span
class=SpellE>app</span> tarafından sunulan ürün ve hizmetlerden ilgili kişileri<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>faydalandırmak için gerekli çalışmaların iş
birimleri tarafından yapılması ve ilgili iş süreçlerinin yürütülmesi, att <span
class=SpellE>app</span> tarafından yürütülen ticari faaliyetlerin
gerçekleştirilmesi için ilgili iş birimleri tarafından gerekli çalışmaların
yapılması ve buna bağlı iş süreçlerinin yürütülmesi, att <span class=SpellE>app</span>
sisteminin ticari ve/veya iş stratejilerinin planlanması ve icrası, att <span
class=SpellE>app</span> ve att <span class=SpellE>app</span> ile iş ilişkisi
içerisinde olan ilgili kişilerin hukuki, teknik ve ticari-iş güvenliğinin
temini ile att <span class=SpellE>app</span> tarafından sunulan ürün ve hizmetlerin
ilgili kişilerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre
özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması için gerekli olan
aktivitelerin planlanması ve icrası da dahil olmak üzere Kanun’un 8. ve 9.
maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde,
uygulama sahibi, yetkilileri, iştiraklerimiz, iş ortaklarımız,
tedarikçilerimiz, hissedarlarımız, kanunen yetkili kamu kurum ve kuruluşları
ile özel kurumlar ile paylaşılabilecektir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Kullanıcının Ad ve İletişim Bilgileri, ödeme
aşamasında onaylayacağı ödeme kuruluşu çerçeve sözleşmesi uyarınca ve 9 Ocak
2008 tarihli ve 26751 sayılı Resmî <span class=SpellE>Gazete’de</span>
yayımlanan Suç Gelirlerinin Aklanmasının ve Terörün Finansmanının Önlenmesine
Dair Tedbirler Hakkında Yönetmelik uyarınca kimlik doğrulaması
gerçekleştirilmesi amacıyla ödeme kuruluşlarıyla paylaşılabilecektir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span class=GramE><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>att</span></span><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'> <span
class=SpellE>app</span>, kişisel verileri yukarıda belirtilen amaçlar
dahilinde, 6698 sayılı Kanun’da öngörülen şartları sağlamak koşulu ile yurt
içinde üçüncü kişilere aktarabileceği gibi yurt dışına da aktarabilecektir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>3. Kişisel Verilerin
Toplanma Yöntemi ve Hukuki Sebebi<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Kişisel veriler, kullanıcılardan elektronik
ortamda toplanmaktadır. Yukarıda belirtilen hukuki sebeplerle toplanan kişisel
veriler Kanun’un 5. ve 6. maddelerinde ve bu Kişisel Verilerin Korunması
Metninde belirtilen amaçlarla işlenebilmekte ve aktarılabilmektedir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>4. Kişisel Verilerin
Saklanma Süreleri<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span class=GramE><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>att</span></span><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'> <span
class=SpellE>app</span>, ilgili kanunlarda ve mevzuatlarda öngörülmesi
durumunda kişisel verileri bu mevzuatlarda belirtilen süre boyunca
saklamaktadır.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Kişisel verilerin ne kadar süre boyunca
saklanması gerektiğine ilişkin mevzuatta bir süre düzenlenmemişse, Kişisel
Veriler att <span class=SpellE>app</span> o veriyi işlerken yürütülen faaliyet
ile bağlı olarak att <span class=SpellE>app</span> uygulamaları ve ticari
yaşamının teamülleri uyarınca işlenmesini gerektiren süre kadar işlenmekte daha
sonra silinmekte, yok edilmekte veya anonim hale getirilmektedir. Kişisel
verilerin işlenme amacı sona ermiş; ilgili mevzuat ve att <span class=SpellE>app</span>
tarafından belirlenen saklama sürelerinin de sonuna gelinmişse; kişisel veriler
yalnızca olası hukuki uyuşmazlıklarda delil teşkil etmesi veya kişisel veriye
bağlı ilgili hakkın ileri sürülebilmesi veya savunmanın tesis edilmesi amacıyla
saklanabilmektedir. Buradaki sürelerin tesisinde bahsi geçen hakkın ileri
sürülebilmesine yönelik zaman aşımı süreleri ile zaman aşımı sürelerinin
geçmesine rağmen daha önce aynı konularda att <span class=SpellE>app</span> yöneltilen
taleplerdeki örnekler esas alınarak saklama süreleri belirlenmektedir. Bu
durumda saklanan<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span class=GramE><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>kişisel</span></span><span
style='font-family:"Arial",sans-serif;color:black;mso-font-kerning:0pt'>
verilere herhangi bir başka amaçla erişilmemekte ve ancak ilgili hukuki
uyuşmazlıkta kullanılması gerektiği zaman ilgili kişisel verilere erişim
sağlanmaktadır. Burada da bahsi geçen süre sona erdikten sonra kişisel veriler
silinmekte, yok edilmekte veya anonim hale getirilmektedir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>5. Kişisel Veri Sahibi
Olarak Kullanıcıların Hakları<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Kanun’un 11. maddesi uyarınca veri sahipleri;<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>(i) kendileri ile ilgili kişisel veri işlenip
işlenmediğini öğrenme,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>(ii) kişisel verileri işlenmişse buna ilişkin
bilgi talep etme,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>(iii) kişisel verilerin işlenme amacını ve
bunların amacına uygun kullanılıp kullanılmadığını öğrenme,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>(iv) yurt içinde veya yurt dışında kişisel
verilerin aktarıldığı üçüncü kişileri bilme,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>(v) kişisel verilerin eksik veya yanlış
işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu kapsamda yapılan
işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>(vi) Kanun ve ilgili diğer kanun hükümlerine
uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin
ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini
isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü
kişilere bildirilmesini isteme,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>(vii) işlenen verilerin münhasıran otomatik
sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir
sonucun ortaya çıkmasına itiraz etme,<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>(viii) kişisel verilerin kanuna aykırı olarak
işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme
haklarına sahiptir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Söz konusu hakların kullanımına ilişkin
talepler, kişisel veri sahipleri att <span class=SpellE>app</span> tarafından
6698 sayılı Kanun Kapsamında belirtilen yöntemlerle iletilebilecektir. <span
class=GramE>att</span> <span class=SpellE>app</span> söz konusu talepleri
değerlendirerek 30 gün içerisinde sonuçlandıracaktır.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>6. Kişisel Verilerin
İşlenmesi ve Elektronik İletişim İzni Onay Metni<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>İşbu Gizlilik/Kişisel Verilerin Korunması
Politikası ve İletişim İznini kabul etmekle, bizimle paylaşılmasına rıza
göstermiş olduğunuz kişisel verilerinizin, tarafınıza çeşitli avantajların
sağlanıp sunulabilmesi ve size özel reklam, satış, pazarlama, anket ve benzer
amaçlı her türlü fiziksel ve elektronik iletişim yapılması ve diğer iletişim
mesajlarının gönderilmesi amacıyla; toplanmasına, saklanmasına, işlenmesine,
kullanılmasına, aktarımına izin vermiş bulunmaktasınız. Bu kişisel verileriniz,
aynı amaçlara yönelik olarak; att <span class=SpellE>app</span> ile tüm
iştirakleri ve bağlı ortaklıkları ile sözleşme ilişkisi içinde olduğumuz yurt
içi ve/veya yurt dışındaki 3. taraflarla paylaşılacaktır. Bunun yanında, bu bilgiler
sadece size sağlanacak hizmetlerin kusursuz sunulabilmesi, olası
gönderilerinizin sağlıklı şekilde teslim edilmesi, telefon, sms, e-posta ve
diğer elektronik iletişim yollarıyla bildirimlerimizin zamanında ulaştırılabilmesi
amacıyla, sözleşme ilişkisi içinde olduğumuz, veri koruması ve güvenliği
konusunda bizimle hukuken ve teknik olarak aynı sorumlulukları taşıyan, ilgili
Mevzuat hükümlerine riayet eden 3. kişilerle, yalnızca ihtiyaç durumunda ve
gerekli ölçüde paylaşılacaktır. Kullanıcılar, kişisel verilerinin att <span
class=SpellE>app</span> tarafından bu şekilde kullanımına ve saklanmasına rıza
gösterdiklerini kabul ve beyan eder. <span class=GramE>att</span> <span
class=SpellE>app</span>, söz konusu kişisel verilerin 6698 sayılı Kişisel
Verilerin Korunması Kanunu Md. 12 uyarınca güvenli şekilde saklanması, yetkisiz
erişimlerin ve hukuka aykırı veri işlemelerin önlenmesi için gereken her türlü
tedbiri alacaktır.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Kişisel Verilerin Korunması Politikası ve
İletişim İznini kabul etmekle, açık rızanızla elektronik haberleşme işletmecisi
tarafından işlenen ve elektronik haberleşme işletmecisiyle aramızdaki hukuki ilişkiye
istinaden bizimle paylaşılan konum verilerinizin, size çeşitli avantajların
sağlanıp sunulabilmesi ve size özel reklam, satış, pazarlama, anket ve benzer
amaçlı her türlü elektronik iletişim yapılması ve diğer iletişim mesajlarının
gönderilmesi amacıyla işlenebilmesine rıza vermiş olacaksınız. İletişim izninizi
geri almak istediğiniz takdirde, dilediğiniz zaman, izni verdiğiniz yöntemle
(sms, e-posta, web sitesi ve diğer usuller) bu talebinizi bize iletebilirsiniz.
Veri Sahibinin Başvuru Hakkı<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Türkiye Cumhuriyeti Anayasası’nın 20. Maddesi
gereğince; herkes, kendisiyle ilgili kişisel verilerin korunmasını isteme
hakkına sahiptir. Bu hak; kişinin kendisiyle ilgili kişisel veriler hakkında bilgilendirilme,
bu verilere erişme, bunların düzeltilmesini veya silinmesini talep etme ve
amaçları doğrultusunda kullanılıp kullanılmadığını öğrenmeyi de kapsar.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>7. Başvuru Hakkının
Kapsamı<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>6698 Sayılı Kişisel Verilerin Korunması
Kanunu’nda (“KVK Kanunu”) ilgili kişi olarak tanımlanan kişisel veri
sahiplerine (“Bundan sonra “Başvuru Sahibi” olarak anılacaktır), KVK Kanununun
11’inci maddesinde kişisel verilerinin işlenmesine ilişkin aşağıda verilen
birtakım taleplerde bulunma hakkı tanınmıştır.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo9;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel veri işlenip işlenmediğini öğrenme,<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo9;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel verileri işlenmişse buna ilişkin bilgi talep
etme,<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo9;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel verilerin işlenme amacını ve bunların amacına
uygun kullanılıp kullanılmadığını öğrenme,<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo9;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Yurt içinde veya yurt dışında kişisel verilerin
aktarıldığı üçüncü kişileri bilme,<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo9;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel verilerin eksik veya yanlış işlenmiş olması
hâlinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel
verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo9;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>KVK Kanunu ve ilgili diğer kanun hükümlerine uygun olarak
işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması
hâlinde kişisel verilerin silinmesini veya yok edilmesini isteme ve bu kapsamda
yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini
isteme,<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo9;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>İşlenen verilerin münhasıran otomatik sistemler
vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun
ortaya çıkmasına itiraz etme,<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='text-align:justify;text-indent:-18.0pt;
mso-list:l1 level1 lfo9;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel verilerin kanuna aykırı olarak işlenmesi
sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>8. Başvuru Hakkı Kapsamı
Dışında Kalan Haller<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>KVK Kanunu’nun 28. Maddesi gereğince
aşağıdaki hallerin KVK Kanunu’nun kapsamında olmaması sebebiyle, kişisel veri
sahiplerinin aşağıda yer alan konularda haklarını ileri sürmeleri mümkün olmayacaktır:<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='text-align:justify;text-indent:-18.0pt;
mso-list:l6 level1 lfo10;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel verilerinin milli savunmayı, milli güvenliği,
kamı güvenliğini, kamu düzenini, ekonomik güvenliği, özel hayatın gizliliğini
veya kişilik haklarını ihlal etmemek ya da suç teşkil etmemek kaydıyla, sanat,
tarih, edebiyat veya bilimsel amaçlarla ya da ifade özgürlüğü kapsamında işlenmesi.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l6 level1 lfo10;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel verilerin resmi istatistik ile anonim hale
getirilmek suretiyle araştırma, planlama ve istatistik gibi amaçlarla
işlenmesi.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l6 level1 lfo10;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel verilerin milli savunmayı, milli güvenliği, kamu
güvenliğini, kamu düzenini veya ekonomik güvenliği sağlamaya yönelik olarak
kanunla görev ve yetki verilmiş kamu kurum ve kuruluşları tarafından yürütülen
önleyici, koruyucu ve istihbarı faaliyetler kapsamında işlenmesi.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='text-align:justify;text-indent:-18.0pt;
mso-list:l6 level1 lfo10;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel verilerin soruşturma, kovuşturma, yargılama veya
infaz işlemlerine ilişkin olarak yargı makamları veya infaz mercileri
tarafından işlenmesi.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>KVK Kanunu’nun 28/2 maddesi gereğince;
aşağıda sıralanan hallerde zararın giderilmesini talep etme hariç olmak üzere,
kişisel veri sahiplerinin haklarını ileri sürmeleri mümkün olmayacaktır:<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='text-align:justify;text-indent:-18.0pt;
mso-list:l8 level1 lfo11;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel veri işleminin suç işlenmesinin önlenmesi veya
suç soruşturması için gerekli olması.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l8 level1 lfo11;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel veri sahibi tarafından kendisi tarafından
alenileştirilmiş kişisel verilerin işlenmesi.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-indent:-18.0pt;
mso-list:l8 level1 lfo11;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel veri işlemenin kanunun verdiği yetkiye
dayanılarak görevli ve yetkili kamu kurum ve kuruluşları ile kamu kurumu
niteliğindeki meslek kuruluşlarınca, denetleme veya düzenleme görevlerinin yürütülmesi
ile disiplin soruşturma veya kovuşturması için gerekli olması.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='text-align:justify;text-indent:-18.0pt;
mso-list:l8 level1 lfo11;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><![if !supportLists]><span
style='font-family:"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";
color:black;mso-font-kerning:0pt'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span style='font-family:"Arial",sans-serif;color:black;
mso-font-kerning:0pt'>Kişisel veri işlemenin bütçe, vergi ve mali konulara
ilişkin olarak Devletin ekonomik ve mali çıkarlarının korunması için gerekli
olması.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>9. Tarafımızın Başvuruları
Sonuçlandırması<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>KVK Kanunu’nun 13. Maddesine uygun olarak
kişisel veri sahiplerinin kişisel verilerine ilişkin taleplerini tarafımıza
yazılı olarak iletmeleri durumunda, tarafımız veri sorumlusu sıfatıyla, talebin
niteliğine göre en kısa sürede ve en geç otuz (30) gün içerisinde
sonuçlandırılmasını sağlayacaktır.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Verilerin güvenliğini sağlama amacıyla,
tarafımızca, başvuruda bulunan kişinin başvuruya konu kişisel verinin sahibi
olup olmadığını tespit etmek amacıyla başvuruda bulunan kişiden bilgi talep edilebilecektir.
Tarafımız ayrıca kişisel veri sahibinin başvurusunun talebe uygun bir biçimde sonuçlandırılmasını
sağlamak adına, kişisel veri sahibine başvurusu ile ilgili soru yöneltebilir.
Veri sahibinin başvurusunun; diğer kişilerin hak ve özgürlüklerini engelleme
ihtimali olması, orantısız çaba gerektirmesi, bilginin kamuya açık bir bilgi
olması gibi durumlarda, tarafımızdan gerekçesi açıklanarak talep
reddedilebilecektir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><b><span style='font-family:
"Arial",sans-serif;color:black;mso-font-kerning:0pt'>10. Veri Sahipleri
Tarafından İzlenecek Başvuru Yöntemi<o:p></o:p></span></b></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Veri sahiplerinin haklarına ilişkin
başvurularını, KVK Kanunu’nun 13. Maddesine uygun bir biçimde, yazılı olarak
veya Kişisel Verilerin Korunması Kurulu tarafından belirlenen diğer yöntemlerle
tarafımıza iletmeleri gerekmektedir. Tarafımıza “yazılı” olarak yapılacak
başvuruların; İadeli taahhütlü mektup, Noter vasıtasıyla, Başvuru sahibinin
şahsen başvurusu ile Başvuru Sahibince 5070 Sayılı Elektronik İmza Kanunu’nda
tanımlı olan “güvenli elektronik imza” ile imzalanarak elektronik posta
adresine gönderilmek suretiyle, tarafımıza iletilebilecektir.<o:p></o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='text-align:justify;tab-stops:28.0pt 56.0pt 84.0pt 112.0pt 140.0pt 168.0pt 196.0pt 224.0pt 252.0pt 280.0pt 308.0pt 336.0pt;
mso-layout-grid-align:none;text-autospace:none'><span style='font-family:"Arial",sans-serif;
color:black;mso-font-kerning:0pt'>Kimliği belirli veya belirlenebilir bir
gerçek kişiye ait olduğu açık olan; kısmen veya tamamen otomatik şekilde veya
veri kayıt sisteminin bir parçası olarak otomatik olmayan şekilde işlenen; att <span
class=SpellE>app’e</span> yöneltilmiş olan her türlü talep veya şikâyetin
alınması ve değerlendirilmesine ilişkin kişisel veriler, att <span
class=SpellE>app</span> tarafından Kişisel Verilerin Korunması ve İşlenmesi
Hakkında Aydınlatma Metnini ve haklarımı okudum, anladım, bilgi sahibi oldum ve
bu kapsamda yukarıda da izah edildiği şekilde kişisel verilerimin kaydedilmesine,
depolanmasına, muhafaza edilmesine, yeniden düzenlenmesine, kanunen bu kişisel verileri
talep etmeye yetkili olan kurumlar ile paylaşılmasını özgür iradem ile kabul
ediyorum.<o:p></o:p></span></p>

    `
return (
    <div className='lg:w-1/2 p-2 text-sm my-5'>
        {Parser(wordContent)}

    </div>
) }